<template>
  <div>
    <button class="btn btn__green btn__small" @click="setModalToggled">Export</button>
    <div v-if="modalToggled" class="action--modal flex__center" @click.self="setModalToggled">
      <div class="action-form tile">
        <p class="text__center text__bold">Choose Data Set(s)</p>
        <p class="flex__between tile--row">
          <span>State Licenses:</span>
          <a v-if="statesURI" :download="statesFile" :href="statesURI">download</a>
        </p>
        <p class="flex__between tile--row">
          <span>Listed Locations:</span>
          <a v-if="locationsURI" :download="locationsFile" :href="locationsURI">download</a>
        </p>
        <p class="flex__between tile--row">
          <span>Licensed Locations:</span>
          <a
            v-if="licensedLocationsURI"
            :download="licensedLocationsFile"
            :href="licensedLocationsURI"
          >download</a>
        </p>
        <button class="btn btn__red btn__small mt-15" @click="setModalToggled">Exit</button>
      </div>
    </div>
  </div>
</template>

<script>
import ObjectsToCsv from "objects-to-csv";
export default {
  props: ["data"],
  data() {
    return {
      modalToggled: false,
      statesURI: null,
      locationsURI: null,
      licensedLocationsURI: null,
      statesFile: "loan-officer-states.csv",
      locationsFile: "loan-officer-listed-locations.csv",
      licensedLocationsFile: "loan-officer-licensed-locations.csv"
    };
  },
  watch: {
    data: function() {
      this.statesURI = null;
      this.locationsURI = null;
      this.licensedLocationsURI = null;
      this.createStatesContent();
      this.createLocationsContent();
      this.createLicensedLocationsContent();
    }
  },
  methods: {
    setModalToggled() {
      return (this.modalToggled = !this.modalToggled);
    },
    async createStatesContent() {
      const copyData = JSON.parse(JSON.stringify(this.data));
      const states = copyData
        .map(officer => {
          return officer.licenses.map(state => {
            return {
              name: officer.display_name,
              title: officer.title,
              email: officer.email,
              nmls: officer.nmls,
              license: state.state,
              live_on_site: officer.status.live ? "Yes" : "No"
            };
          });
        })
        .flat();
      const statesContent = await new ObjectsToCsv(states).toString(true, true);
      this.statesURI = `data:text/csv;charset=utf-8,${encodeURI(
        statesContent
      )}`;
    },
    async createLocationsContent() {
      const copyData = JSON.parse(JSON.stringify(this.data));
      const locations = copyData
        .map(officer => {
          if (officer.locations.length > 0) {
            return officer.locations.map(location => {
              const isLicensed =
                officer.licensed_locations.filter(place => {
                  return place._id === location._id;
                }).length > 0;
              return {
                name: officer.display_name,
                title: officer.title,
                email: officer.email,
                nmls: officer.nmls,
                licenses: officer.licenses.map(state => state.state).join(", "),
                listed_address: location.address.street,
                listed_city: location.address.city,
                listed_state: location.address.state,
                listed_zip: location.address.zip,
                listed_nmls: location.nmls,
                licensed_at_location: isLicensed ? "Yes" : "No",
                live_on_site: officer.status.live ? "Yes" : "No"
              };
            });
          } else {
            return {
              name: officer.display_name,
              title: officer.title,
              email: officer.email ? officer.email : "unknown",
              nmls: officer.nmls ? officer.nmls : "unknown",
              licenses:
                officer.licenses.length > 0
                  ? officer.licenses.map(state => state.state).join(", ")
                  : "none",
              listed_address: "",
              listed_city: "",
              listed_state: "",
              listed_zip: "",
              listed_nmls: "",
              listed_at_location: "",
              live_on_site: officer.status.live ? "Yes" : "No"
            };
          }
        })
        .flat();

      const locationsContent = await new ObjectsToCsv(locations).toString(
        true,
        true
      );
      this.locationsURI = `data:text/csv;charset=utf-8,${encodeURI(
        locationsContent
      )}`;
    },
    async createLicensedLocationsContent() {
      const copyData = JSON.parse(JSON.stringify(this.data));
      const locations = copyData
        .map(officer => {
          if (officer.licensed_locations.length > 0) {
            return officer.licensed_locations.map(location => {
              const isListed =
                officer.locations.filter(place => {
                  return place._id === location._id;
                }).length > 0;
              return {
                name: officer.display_name,
                title: officer.title,
                email: officer.email,
                nmls: officer.nmls ? officer.nmls : "unknown",
                licenses: officer.licenses.map(state => state.state).join(", "),
                licensed_address: location.address.street,
                licensed_city: location.address.city,
                licensed_state: location.address.state,
                licensed_zip: location.address.zip,
                licensed_nmls: location.nmls,
                listed_at_location: isListed ? "Yes" : "No",
                live_on_site: officer.status.live ? "Yes" : "No"
              };
            });
          } else {
            return {
              name: officer.display_name,
              title: officer.title,
              email: officer.email ? officer.email : "unknown",
              nmls: officer.nmls ? officer.nmls : "unknown",
              licenses:
                officer.licenses.length > 0
                  ? officer.licenses.map(state => state.state).join(", ")
                  : "none",
              licensed_address: "",
              licensed_city: "",
              licensed_state: "",
              licensed_zip: "",
              licensed_nmls: "",
              listed_at_location: "",
              live_on_site: officer.status.live ? "Yes" : "No"
            };
          }
        })
        .flat();
      // add check to see if location is listed
      const locationsContent = await new ObjectsToCsv(locations).toString(
        true,
        true
      );
      this.licensedLocationsURI = `data:text/csv;charset=utf-8,${encodeURI(
        locationsContent
      )}`;
    }
  },
  mounted() {
    this.createStatesContent();
    this.createLocationsContent();
    this.createLicensedLocationsContent();
  }
};
</script>

<style scoped lang="scss">
</style>